"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentLayoutOverrideProcessor = void 0;
var UIComponentLayoutOverrides_1 = require("../UIComponentLayoutOverrides");
var Container_1 = require("../components/Container");
var SettingsPanelItem_1 = require("../components/settings/SettingsPanelItem");
var ConstructorUtils_1 = require("./ConstructorUtils");
var ComponentLayoutOverrideProcessor = /** @class */ (function () {
    function ComponentLayoutOverrideProcessor(config) {
        this.config = config;
    }
    ComponentLayoutOverrideProcessor.prototype.process = function (uiContainer, variantIdentifier) {
        if (this.config.componentLayoutOverrides === undefined) {
            return;
        }
        this.removeExcludedComponents(uiContainer, variantIdentifier);
    };
    ComponentLayoutOverrideProcessor.prototype.removeExcludedComponents = function (container, variantIdentifier) {
        var _this = this;
        var components = container.getComponents().slice();
        components.forEach(function (component) {
            if (_this.shouldExclude(component, variantIdentifier)) {
                container.removeComponent(component);
                _this.releaseComponentTree(component);
            }
            else if (component instanceof Container_1.Container) {
                _this.removeExcludedComponents(component, variantIdentifier);
            }
        });
    };
    ComponentLayoutOverrideProcessor.prototype.shouldExclude = function (component, variantIdentifier) {
        if (this.resolveComponentLayoutOverride(component, variantIdentifier) === UIComponentLayoutOverrides_1.UIComponentLayoutOverride.Exclude) {
            return true;
        }
        // Settings rows own their nested setting component, so excluding the nested component removes the whole row.
        if (component instanceof SettingsPanelItem_1.SettingsPanelItem) {
            var settingComponent = component.getConfig().settingComponent;
            return (settingComponent != null &&
                this.resolveComponentLayoutOverride(settingComponent, variantIdentifier) === UIComponentLayoutOverrides_1.UIComponentLayoutOverride.Exclude);
        }
        return false;
    };
    ComponentLayoutOverrideProcessor.prototype.resolveComponentLayoutOverride = function (component, variantIdentifier) {
        var componentLayoutOverrides = this.config.componentLayoutOverrides;
        var componentTypeNames = (0, ConstructorUtils_1.getConstructorNames)(component.constructor);
        var override = UIComponentLayoutOverrides_1.UIComponentLayoutOverride.Include;
        var resolveConfig = function (componentLayoutOverrides) {
            var _a;
            var componentLayoutOverrideMap = componentLayoutOverrides;
            for (var _i = 0, componentTypeNames_1 = componentTypeNames; _i < componentTypeNames_1.length; _i++) {
                var componentTypeName = componentTypeNames_1[_i];
                override = (_a = componentLayoutOverrideMap[componentTypeName]) !== null && _a !== void 0 ? _a : override;
            }
        };
        resolveConfig(componentLayoutOverrides);
        if (componentLayoutOverrides[variantIdentifier] != null) {
            resolveConfig(componentLayoutOverrides[variantIdentifier]);
        }
        return override;
    };
    ComponentLayoutOverrideProcessor.prototype.releaseComponentTree = function (component, releasedComponents) {
        if (releasedComponents === void 0) { releasedComponents = []; }
        // Guard against shared or circular component references causing duplicate release calls.
        if (releasedComponents.indexOf(component) !== -1) {
            return;
        }
        releasedComponents.push(component);
        if (component instanceof SettingsPanelItem_1.SettingsPanelItem) {
            var settingComponent = component.getConfig().settingComponent;
            if (settingComponent != null) {
                this.releaseComponentTree(settingComponent, releasedComponents);
            }
        }
        if (component instanceof Container_1.Container) {
            var childComponents = component.getComponents().slice();
            for (var _i = 0, childComponents_1 = childComponents; _i < childComponents_1.length; _i++) {
                var childComponent = childComponents_1[_i];
                this.releaseComponentTree(childComponent, releasedComponents);
            }
        }
        component.release();
    };
    return ComponentLayoutOverrideProcessor;
}());
exports.ComponentLayoutOverrideProcessor = ComponentLayoutOverrideProcessor;
